module.exports = __webpack_public_path__ + "static/media/product29.a98039e1.jpg";